import { useContext } from 'react'
import { ClientContext } from '../contexts'

export const useClientContext = () => useContext(ClientContext)
